import { Question } from '../types';

export const fiqh101QuestionsExtra: Question[] = [
  {
    id: 'fiqh93',
    text: 'What does the course explain about the role of fatwa in different cultural contexts?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Fatwa methodologies differ between regions that have lived under Muslim rule versus as minorities', isCorrect: true },
      { id: 'b', text: 'Indian subcontinent scholars developed approaches for Muslims living as minorities', isCorrect: true },
      { id: 'c', text: 'Middle Eastern fatwa approaches often assumed state support for Islamic institutions', isCorrect: true },
      { id: 'd', text: 'All regions should follow identical fatwa approaches regardless of context', isCorrect: false }
    ],
    explanation: 'The course explains that fatwa methodologies differ between regions based on historical context. Scholars from the Indian subcontinent developed approaches for Muslims living as minorities under non-Muslim rule, addressing issues like whether food was halal and establishing independent institutions. In contrast, Middle Eastern approaches often assumed state support for Islamic institutions, where asking if food was halal would be almost an insult to the Islamic system.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh94',
    text: 'What was the example in the course of a problematic fatwa given to Muslims in America?',
    type: 'single',
    options: [
      { id: 'a', text: 'Permission to eat non-zabiha meat', isCorrect: false },
      { id: 'b', text: 'Approval of temporary marriages with Christian women during educational visas', isCorrect: true },
      { id: 'c', text: 'Prohibition on attending public schools', isCorrect: false },
      { id: 'd', text: 'Requirement to speak only Arabic in public', isCorrect: false }
    ],
    explanation: 'The course mentions a problematic fatwa where scholars from overseas approved temporary marriages with Christian women for Muslim students on educational visas in the US. After their studies, many students returned to their home countries, abandoning their Christian wives and children, creating what became known as "the forgotten children of Saudi Arabia." This example demonstrates the importance of understanding context when issuing fatwas.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh95',
    text: 'What is the meaning of Istihsan according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Strict adherence to the literal text', isCorrect: false },
      { id: 'b', text: 'Preference for one ruling over another based on public welfare or equity', isCorrect: true },
      { id: 'c', text: 'Ignoring established legal principles', isCorrect: false },
      { id: 'd', text: 'Reliance on personal opinion', isCorrect: false }
    ],
    explanation: 'Istihsan means preference for one ruling over another based on public welfare or equity. It is a tool used by scholars to avoid strict adherence to the literal text when it leads to undesirable outcomes.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh96',
    text: 'What is the role of local custom (\'urf) in issuing fatwas according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Local custom is irrelevant in Islamic law', isCorrect: false },
      { id: 'b', text: 'Local custom can influence the interpretation and application of Islamic law', isCorrect: true },
      { id: 'c', text: 'Fatwas must always contradict local customs', isCorrect: false },
      { id: 'd', text: 'Local custom can override clear textual evidence', isCorrect: false }
    ],
    explanation: 'Local custom (\'urf) can influence the interpretation and application of Islamic law. Scholars consider the customs of a community when issuing fatwas, as long as those customs do not contradict clear textual evidence.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh97',
    text: 'What is the meaning of Maqasid al-Shariah according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'The literal meanings of legal texts', isCorrect: false },
      { id: 'b', text: 'The underlying objectives and purposes of Islamic law', isCorrect: true },
      { id: 'c', text: 'The historical context of legal rulings', isCorrect: false },
      { id: 'd', text: 'The consensus of early scholars', isCorrect: false }
    ],
    explanation: 'Maqasid al-Shariah refers to the underlying objectives and purposes of Islamic law, such as the preservation of religion, life, intellect, lineage, and wealth. Understanding these objectives helps scholars derive rulings that align with the spirit of Islamic law.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh98',
    text: 'What are the five necessities (daruriyyat) that Maqasid al-Shariah seeks to protect according to the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Religion (din)', isCorrect: true },
      { id: 'b', text: 'Life (nafs)', isCorrect: true },
      { id: 'c', text: 'Intellect (\'aql)', isCorrect: true },
      { id: 'd', text: 'Lineage (nasl)', isCorrect: true },
      { id: 'e', text: 'Wealth (mal)', isCorrect: true },
      { id: 'f', text: 'Power (sultan)', isCorrect: false }
    ],
    explanation: 'The five necessities (daruriyyat) that Maqasid al-Shariah seeks to protect are: religion (din), life (nafs), intellect (\'aql), lineage (nasl), and wealth (mal). These are considered essential for individual and societal well-being.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh99',
    text: 'What is the difference between daruriyyat, hajiyyat, and tahsiniyyat in Maqasid al-Shariah according to the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Daruriyyat are necessities, hajiyyat are needs, and tahsiniyyat are refinements', isCorrect: true },
      { id: 'b', text: 'Daruriyyat are recommended, hajiyyat are obligatory, and tahsiniyyat are prohibited', isCorrect: false },
      { id: 'c', text: 'Daruriyyat are private, hajiyyat are public, and tahsiniyyat are individual', isCorrect: false },
      { id: 'd', text: 'Daruriyyat are fixed, hajiyyat are flexible, and tahsiniyyat are optional', isCorrect: false }
    ],
    explanation: 'In Maqasid al-Shariah, daruriyyat are necessities (essential for survival), hajiyyat are needs (remove hardship), and tahsiniyyat are refinements (enhance quality of life).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh100',
    text: 'What is the meaning of Sadd al-Dhara\'i according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Opening the doors to all interpretations', isCorrect: false },
      { id: 'b', text: 'Blocking the means to evil', isCorrect: true },
      { id: 'c', text: 'Encouraging unrestricted freedom', isCorrect: false },
      { id: 'd', text: 'Ignoring potential consequences', isCorrect: false }
    ],
    explanation: 'Sadd al-Dhara\'i means blocking the means to evil. It is a legal principle that prohibits actions that may lead to harmful outcomes, even if the actions themselves are permissible.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh101',
    text: 'What is the role of Qiyas (analogical reasoning) in fiqh according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Qiyas is the primary source of Islamic law', isCorrect: false },
      { id: 'b', text: 'Qiyas extends existing rulings to new situations based on shared characteristics', isCorrect: true },
      { id: 'c', text: 'Qiyas is only used when there is clear textual evidence', isCorrect: false },
      { id: 'd', text: 'Qiyas is based on personal preference', isCorrect: false }
    ],
    explanation: 'Qiyas (analogical reasoning) extends existing rulings to new situations based on shared characteristics. It is a method of legal reasoning used when there is no direct textual evidence for a particular issue.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh102',
    text: 'What are the essential elements of Qiyas (analogical reasoning) according to the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Asl (original case)', isCorrect: true },
      { id: 'b', text: '\'Illa (effective cause)', isCorrect: true },
      { id: 'c', text: 'Far\' (new case)', isCorrect: true },
      { id: 'd', text: 'Hukm (ruling)', isCorrect: true },
      { id: 'e', text: 'Zann (speculation)', isCorrect: false }
    ],
    explanation: 'The essential elements of Qiyas (analogical reasoning) are: Asl (original case), \'Illa (effective cause), Far\' (new case), and Hukm (ruling).',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh103',
    text: 'What is the meaning of Istishab according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Presumption of continuity', isCorrect: true },
      { id: 'b', text: 'Changing rulings based on new evidence', isCorrect: false },
      { id: 'c', text: 'Ignoring past precedents', isCorrect: false },
      { id: 'd', text: 'Reliance on personal opinion', isCorrect: false }
    ],
    explanation: 'Istishab means presumption of continuity. It is a legal principle that assumes a state of affairs remains as it was unless there is evidence to the contrary.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh104',
    text: 'What is the role of Ijma (consensus) in fiqh according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Ijma can override clear textual evidence', isCorrect: false },
      { id: 'b', text: 'Ijma is a secondary source of Islamic law', isCorrect: true },
      { id: 'c', text: 'Ijma is based on personal opinions', isCorrect: false },
      { id: 'd', text: 'Ijma is irrelevant in modern times', isCorrect: false }
    ],
    explanation: 'Ijma (consensus) is a secondary source of Islamic law. It refers to the agreement of qualified scholars on a legal ruling. It is considered binding and authoritative.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh105',
    text: 'What are the conditions for a valid Ijma (consensus) according to the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Agreement of all qualified scholars', isCorrect: true },
      { id: 'b', text: 'Based on clear textual evidence', isCorrect: true },
      { id: 'c', text: 'Unanimous opinion', isCorrect: true },
      { id: 'd', text: 'Agreement of political leaders', isCorrect: false }
    ],
    explanation: 'The conditions for a valid Ijma (consensus) are: agreement of all qualified scholars, based on clear textual evidence, and unanimous opinion.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh106',
    text: 'What is the meaning of Maslaha Mursala according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Unrestricted public interest', isCorrect: false },
      { id: 'b', text: 'Considerations of public interest not explicitly supported or rejected by textual evidence', isCorrect: true },
      { id: 'c', text: 'Ignoring public welfare', isCorrect: false },
      { id: 'd', text: 'Reliance on personal opinion', isCorrect: false }
    ],
    explanation: 'Maslaha Mursala refers to considerations of public interest not explicitly supported or rejected by textual evidence. It is a legal principle used to derive rulings that serve the welfare of the community.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh107',
    text: 'What are the conditions for using Maslaha Mursala according to the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Must serve a genuine public interest', isCorrect: true },
      { id: 'b', text: 'Must not contradict clear textual evidence', isCorrect: true },
      { id: 'c', text: 'Must be based on speculation', isCorrect: false },
      { id: 'd', text: 'Must be based on personal opinion', isCorrect: false }
    ],
    explanation: 'The conditions for using Maslaha Mursala are: must serve a genuine public interest and must not contradict clear textual evidence.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh108',
    text: 'What is the meaning of Istihsan according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Preference for one ruling over another based on stronger evidence', isCorrect: true },
      { id: 'b', text: 'Ignoring established legal principles', isCorrect: false },
      { id: 'c', text: 'Reliance on personal opinion', isCorrect: false },
      { id: 'd', text: 'Strict adherence to the literal text', isCorrect: false }
    ],
    explanation: 'Istihsan means preference for one ruling over another based on stronger evidence or considerations of equity. It is a tool used by scholars to avoid strict adherence to the literal text when it leads to undesirable outcomes.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh109',
    text: 'What are the different types of Istihsan according to the course?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Istihsan based on necessity', isCorrect: true },
      { id: 'b', text: 'Istihsan based on public interest', isCorrect: true },
      { id: 'c', text: 'Istihsan based on custom', isCorrect: true },
      { id: 'd', text: 'Istihsan based on speculation', isCorrect: false }
    ],
    explanation: 'The different types of Istihsan are: Istihsan based on necessity, Istihsan based on public interest, and Istihsan based on custom.',
    topic: 'fiqh101'
  },
  {
    id: 'fiqh110',
    text: 'What is the original title of Sahih al-Bukhari according to the course?',
    type: 'single',
    options: [
      { id: 'a', text: 'Jami\' al-Sahih', isCorrect: false },
      { id: 'b', text: 'Al-Jami\' al-Musnad al-Sahih al-Mukhtasar min \'Umuri Rasul Allah wa Sunanihi wa Ayyamihi', isCorrect: true },
      { id: 'c', text: 'Sahih al-Ahadith', isCorrect: false },
      { id: 'd', text: 'Kitab al-Jami\'', isCorrect: false }
    ],
    explanation: 'According to the course, the original title of Sahih al-Bukhari is "Al-Jami\' al-Musnad al-Sahih al-Mukhtasar min \'Umuri Rasul Allah wa Sunanihi wa Ayyamihi," which translates to "The Abridged Collection of Authentic Hadiths with Connected Chains Regarding Matters Pertaining to the Messenger of Allah, His Practices, and His Times." The word "Mukhtasar" (abridged/summary) indicates it was never meant to be comprehensive.',
    topic: 'fiqh101'
  }
];
